import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const mainCategories = categories.slice(0, 5);
const resourceLinks = [
  { name: "Spreadsheet Guide", url: "/article/what-is-oopbuy-spreadsheet" },
  { name: "Category List", url: "https://kaspreadsheet.com/", external: true },
  { name: "Compare Tools", url: "https://kaspreadsheet.com/", external: true },
  { name: "Dropshipping Tips", url: "https://kaspreadsheet.com/", external: true },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
        <div className="bg-background-50 rounded-[28px] p-8 md:p-12">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Brand */}
            <div className="lg:w-1/4">
              <Link to="/" className="inline-block">
                <span className="text-xl font-bold text-foreground-950 font-heading tracking-tight">
                  OOPBuy <span className="font-normal text-foreground-600">Spreadsheets</span>
                </span>
              </Link>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                The most comprehensive resource for comparing, discovering, and learning about OOPBuy spreadsheet systems. Built for dropshippers and e-commerce professionals.
              </p>
            </div>

            {/* Categories Column */}
            <div className="lg:w-1/4">
              <h3 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-5">Categories</h3>
              <div className="space-y-3">
                {mainCategories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Resources Column */}
            <div className="lg:w-1/4">
              <h3 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-5">Resources</h3>
              <div className="space-y-3">
                {resourceLinks.map((link, i) =>
                  link.external ? (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-150"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      key={i}
                      to={link.url}
                      className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-150"
                    >
                      {link.name}
                    </Link>
                  )
                )}
              </div>
            </div>

            {/* Legal Column */}
            <div className="lg:w-1/4">
              <h3 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-5">Legal</h3>
              <div className="space-y-3">
                <span className="block text-sm text-foreground-500">Privacy Policy</span>
                <span className="block text-sm text-foreground-500">Terms of Use</span>
                <span className="block text-sm text-foreground-500">Disclaimer</span>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-150"
                >
                  External Links Policy
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 OOPBuy Spreadsheets &nbsp;|&nbsp;
              <Link to="/" className="hover:text-foreground-700 transition-colors">Home</Link>
              &nbsp;|&nbsp;
              <Link to="/article/what-is-oopbuy-spreadsheet" className="hover:text-foreground-700 transition-colors">Guide</Link>
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 text-sm hover:bg-foreground-800 transition-colors"
                aria-label="Visit Kaspreadsheet"
              >
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}